<template>
  <nav
    id="MainHeader"
    class="fixed top-0 left-0 right-0 z-50 py-4 transition-all duration-300 bg-white shadow-sm"
  >
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-12">
        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-3 select-none group">
          <div class="relative h-10 shrink-0">
            <!-- SVG Logo Inline -->
            <img
              :src="
                $store.getters.getImageUrl(
                  $store.getters.getThemeColumn('header_logo')
                )
              "
              class="object-contain w-full h-full"
              :alt="$store.getters.getThemeColumn('company_name')"
            />
          </div>
        </router-link>

        <!-- Desktop Menu -->
        <div class="items-center hidden space-x-6 md:flex lg:space-x-8">
          <router-link
            to="/news"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >最新消息</router-link
          >
          <router-link
            to="/knowledge"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >醫學專欄</router-link
          >
          <router-link
            to="/about"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >關於我們</router-link
          >
          <router-link
            to="/doctors"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >醫師團隊</router-link
          >
          <router-link
            to="/hours"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >門診時間</router-link
          >
          <router-link
            to="/services"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >診療項目</router-link
          >
          <!-- <router-link
            to="/progress"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >看診進度</router-link
          > -->
          <router-link
            to="/traffic"
            class="font-medium transition-colors text-slate-600 hover:text-brand-darkBlue"
            >交通資訊</router-link
          >
          <!-- <a
            href="tel:0424376568"
            class="flex items-center gap-2 px-4 py-2 text-white transition-all rounded-full shadow-md bg-brand-blue hover:bg-brand-darkBlue hover:shadow-lg"
          >
            <i data-lucide="phone" class="w-4 h-4"></i>
            <span>預約掛號</span>
          </a> -->
        </div>

        <!-- Mobile Menu Button -->
        <button
          id="mobile-menu-btn"
          @click="ToggleMenu"
          class="p-2 md:hidden text-slate-600 hover:text-brand-blue"
        >
          <i data-lucide="menu" class="w-7 h-7"></i>
        </button>
      </div>
    </div>

    <MainMenu ref="MainMenu" />
  </nav>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue";
export default {
  name: "MainHeader",
  components: {
    MainMenu,
  },
  methods: {
    ToggleMenu() {
      const status = !this.$refs.MainMenu.openStatus;
      this.$refs.MainMenu.setMenuOpenStatus(status);
    },
  },
};
</script>
